import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Buffer Levels configuration',
  attributeName: 'bufferLevels',
  fields: [
    {
      attributeName: 'desiredBufferSize',
      helpText: 'The desired buffer size (for the load control). This is the size of both the video and audio buffers in the player. (milliseconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Desired Buffer Size',
      placeholder: 'Input the desired buffer size ...',
      default: 0,
    },
    {
      attributeName: 'firstBufferSize',
      helpText: ' First buffer time: how much buffer to load the first time (miliseconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'First Buffer Size',
      placeholder: 'Input a first buffer size...',
      default: 0,
    },
    {
      attributeName: 'rebufferSize',
      helpText: 'Rebuffer size, how much buffer to have after a buffering event (milliseconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Rebuffer Size',
      placeholder: 'Input a rebuffer size...',
      default: 0,
    },
  ],
};
